import { Button } from "@/components/ui/button";
import heroImage from "@/assets/hero-meal.jpg";

const HeroSection = () => {
  const scrollToRegistration = () => {
    document
      .getElementById("registration")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="hero-gradient section-padding-large min-h-screen flex items-center"
    >
      <div className="container-wide">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-6">
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold font-heading text-foreground leading-tight">
                Revive Your Health with{" "}
                <span className="text-primary">Fresh</span> Meals
              </h1>
              <p className="text-xl text-muted-foreground font-body leading-relaxed max-w-2xl">
                Want to simplify healthy eating without sacrificing flavor?
                Revive Meal Ethiopia offers personalized meal prep, custom meal
                plans, and vibrant event catering, all inspired by the goodness
                of Ethiopian cuisine. See what we can create for you.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="btn-hover-lift text-lg px-8 py-4 bg-primary hover:bg-primary-hover font-medium"
                onClick={scrollToRegistration}
              >
                Start Your Journey
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="text-lg px-8 py-4 border-primary text-primary hover:bg-primary-light font-medium"
                onClick={() =>
                  document
                    .getElementById("about")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
              >
                Learn More
              </Button>
            </div>

            <div className="flex items-center space-x-8 pt-4">
              <div className="flex items-center space-x-2">
                <div className="w-12 h-12 bg-primary-light rounded-full flex items-center justify-center">
                  <span className="text-primary font-bold text-lg">🥗</span>
                </div>
                <div>
                  <p className="font-semibold text-foreground">Fresh Daily</p>
                  <p className="text-sm text-muted-foreground">
                    Made with love
                  </p>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <div className="w-12 h-12 bg-primary-light rounded-full flex items-center justify-center">
                  <span className="text-primary font-bold text-lg">🚀</span>
                </div>
                <div>
                  <p className="font-semibold text-foreground">Fast Delivery</p>
                  <p className="text-sm text-muted-foreground">
                    Right to your door
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-strong">
              <img
                src={heroImage}
                alt="Fresh healthy Ethiopian meal prep containers with vibrant vegetables and grains"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent"></div>
            </div>

            {/* Floating stats */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-medium p-6 card-hover">
              <div className="text-center">
                <p className="text-3xl font-bold text-primary font-heading">
                  500+
                </p>
                <p className="text-sm text-muted-foreground font-body">
                  Happy Customers
                </p>
              </div>
            </div>

            <div className="absolute -top-6 -right-6 bg-white rounded-2xl shadow-medium p-6 card-hover">
              <div className="text-center">
                <p className="text-3xl font-bold text-primary font-heading">
                  100%
                </p>
                <p className="text-sm text-muted-foreground font-body">
                  Fresh & Natural
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
